module.exports = __webpack_public_path__ + "img/商业建筑_01.4f2d23a2.png";